import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "offer-list" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", {
  role: "separator",
  "aria-orientation": "horizontal",
  class: "v-divider",
  theme: "light"
}, null, -1)

import {computed, ref, watch} from 'vue';
import FilterList from '@/components/FilterList.vue';
import Pagination from '@/components/Pagination.vue';
import Error from '@/components/Error.vue';
import Loading from '@/components/Loading.vue';
import {useStorage} from '@/composables/storage';
import useOffersStore from '@/store/offers';
import {useFilterSort} from '@/composables/filterSort';


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferList',
  emits: ['close'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emits = __emit;
const store = useOffersStore();

useStorage(
    store,
    (offers, route) => route?.params.name ? `Angebote ${route?.params.name}` : 'Angebote',
    (route, _originalFilters, defaultFilters) => {
      return {
        ...defaultFilters,
        KundenNr: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id),
      };
    },
);
const {filters, save} = useFilterSort(store, emits);

const searchDebounceTimeout = ref<NodeJS.Timeout | null>(null);

function doSearch() {
  if (searchDebounceTimeout.value) clearTimeout(searchDebounceTimeout.value);
  save();
}

const fulltextSearch = computed({
  get(): string {
    return filters.value.Fulltext$Fulltext.words.join(' ');
  },
  set(val: string) {
    if (!val) {
      filters.value.Fulltext$Fulltext.words = [];
      return;
    }
    filters.value.Fulltext$Fulltext.words = val.split(' ');
  },
});

watch(fulltextSearch, (newVal: string, oldVal: string) => {
  if (newVal === oldVal || newVal.length < 3) return;
  if (searchDebounceTimeout.value) clearTimeout(searchDebounceTimeout.value);

  searchDebounceTimeout.value = setTimeout(() => {
    doSearch();
  }, 500);
});

__expose({
  FilterList,
  Pagination,
  Error,
  Loading,
  fulltextSearch,
  doSearch,
  store,
});


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_text_field, {
      label: "Suche",
      variant: "filled",
      modelValue: fulltextSearch.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fulltextSearch).value = $event)),
      "append-inner-icon": "mdi-magnify",
      "onClick:appendInner": doSearch,
      onKeypress: _withKeys(doSearch, ["enter"]),
      "hide-details": "",
      loading: _unref(store).loading
    }, null, 8, ["modelValue", "loading"]),
    (!_unref(store).loading && _unref(store).displayFilters.length > 0)
      ? (_openBlock(), _createBlock(_component_v_container, {
          key: 0,
          fluid: ""
        }, {
          default: _withCtx(() => [
            _createVNode(FilterList, { store: _unref(store) }, null, 8, ["store"])
          ], undefined, true),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_unref(store).loading && !_unref(store).error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data, (offer) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: offer.AngebotNr
                }, [
                  _createVNode(_component_v_list_item, {
                    link: "",
                    to: {
              name: 'customer_offer_details',
              params: { id: _ctx.$route.params.id, offer_id: offer.AngebotNr },
            },
                    class: "order-item"
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_v_list_item_action, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            color: offer.color
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(offer.icon), 1)
                            ], undefined, true),
                            _: 2
                          }, 1032, ["color"])
                        ], undefined, true),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Angebot " + _toDisplayString(offer.AngebotNr), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_list_item_subtitle, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(`${offer.DatumFormatted} ${offer.UhrZeit} Uhr`), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["to"]),
                  _hoisted_3
                ], 64))
              }), 128))
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_v_container, {
            fluid: "",
            class: "mb-10"
          }, {
            default: _withCtx(() => [
              _createVNode(Pagination, {
                module: _unref(store).$id
              }, null, 8, ["module"])
            ], undefined, true),
            _: 1
          })
        ]))
      : (_unref(store).error)
        ? (_openBlock(), _createBlock(_component_v_container, {
            key: 2,
            class: "py-1",
            fluid: ""
          }, {
            default: _withCtx(() => [
              _createVNode(Error, {
                module: _unref(store).$id
              }, null, 8, ["module"])
            ], undefined, true),
            _: 1
          }))
        : (_openBlock(), _createBlock(Loading, { key: 3 }))
  ]))
}
}

})